import { Checkbox, Form, Radio } from 'antd'
import { FormikHelpers, FormikState } from 'formik'
import Card from 'components/card/Card'
import CardHeaderForm from 'components/card/CardHeaderForm'
import RequiredMark from 'components/form/RequiredMark'
import FormProductPriceValue from 'constants/interfaceFormik/productStockPrice'

interface ConfigurationProps {
  state: FormikState<FormProductPriceValue>
  helpers: FormikHelpers<FormProductPriceValue>
}

export default function Configuration(props: ConfigurationProps) {
  const {
    helpers: { setFieldValue },
    state: { values },
  } = props

  const styleBoxShadow = {
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
  }

  return (
    <Card className="rounded-xl py-6 px-0" dataTestId="form_configuration">
      <CardHeaderForm title="3. Konfigurasi" />
      <Card.Body className="mt-0 px-6">
        <Form
          className="flex flex-col gap-3 xl:gap-9"
          layout="horizontal"
          preserve={false}
          colon={false}
          requiredMark={RequiredMark}
          labelCol={{ prefixCls: 'xl:w-3/12 font-bold' }}
          labelAlign="left"
          labelWrap
          wrapperCol={{ prefixCls: 'xl:w-9/12' }}
          style={{ maxWidth: '100%' }}
        >
          <Form.Item
            label={<label className="text-base text-[#323539] m-0">Tampilkan Pada</label>}
            className="mb-0"
            wrapperCol={{ prefixCls: 'xl:flex xl:gap-6' }}
          >
            <div className="w-full xl:grid xl:grid-cols-2 xl:gap-3 checkbox-admin">
              <div className="px-2 py-4 rounded-lg" style={styleBoxShadow}>
                <Checkbox
                  data-testid="checkbox_IsShowMember"
                  checked={values.isShowMember}
                  onChange={() => setFieldValue('isShowMember', !values.isShowMember)}
                >
                  <CheckboxShown appName="Agen" />
                </Checkbox>
              </div>
              <div className="px-2 py-4 rounded-lg" style={styleBoxShadow}>
                <Checkbox
                  data-testid="checkbox_IsShowWorker"
                  checked={values.isShowWorker}
                  onChange={() => setFieldValue('isShowWorker', !values.isShowWorker)}
                >
                  <CheckboxShown appName="Pekerja" />
                </Checkbox>
              </div>
              <div className="px-2 py-4 rounded-lg" style={styleBoxShadow}>
                <Checkbox
                  data-testid="checkbox_IsShowFarmer"
                  checked={values.isShowFarmer}
                  onChange={() => setFieldValue('isShowFarmer', !values.isShowFarmer)}
                >
                  <CheckboxShown appName="Petani" />
                </Checkbox>
              </div>
              <div className="px-2 py-4 rounded-lg" style={styleBoxShadow}>
                <Checkbox
                  data-testid="checkbox_isShowAmbassador"
                  checked={values.isShowAmbassador}
                  onChange={() => setFieldValue('isShowAmbassador', !values.isShowAmbassador)}
                >
                  <CheckboxShown appName="Duta" />
                </Checkbox>
              </div>
            </div>
          </Form.Item>

          <Form.Item
            label={
              <div className="text-base font-medium text-[#323539] m-0 inline">Status Produk</div>
            }
            className="mb-0"
            required
            valuePropName="isActive"
            wrapperCol={{ prefixCls: 'xl:flex xl:gap-6' }}
          >
            <Radio.Group
              data-testid="radioGroup_isActive"
              onChange={e => setFieldValue('isActive', e.target.value)}
              value={values.isActive}
            >
              <Radio data-testid="radio_isActive_active" value={true}>
                Aktif
              </Radio>
              <Radio data-testid="radio_isActive_inActive" value={false}>
                Tidak Aktif
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Card.Body>
    </Card>
  )
}

function CheckboxShown({ appName }: { appName: string }) {
  return (
    <div className="flex gap-4 pl-2">
      <img src="/media/logoSawitpro.png" width={36} alt="sawitpro" />
      <span className="self-center text-[#323539]">Aplikasi {appName}</span>
    </div>
  )
}
